import type {RouteLocationNormalizedGeneric} from 'vue-router';

/**
 * Hands the navigation over to the legacy Meteor app. The return url is stored in localstorage so
 * Meteor can redirect back to this page afterwards.
 */
export const redirectToMeteor = (to: RouteLocationNormalizedGeneric): false => {
  localStorage.setItem('vueReturnUrl', to.fullPath);
  window.location.replace('/meteor');

  return false;
};
